var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point"},[_vm._m(0),_c('div',{staticClass:"point-text"},[_vm._v(_vm._s(_vm.point))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-bg"},[_c('img',{attrs:{"src":require("@img/misc/winning-point.png")}})])
}]

export { render, staticRenderFns }